import { css } from "styled-components";

const variables = css`
  :root {
    --primary-dark:#F57E00;
    --primary:#FF9933;
    --primary-light:#FFCC99;

    --selected:#FFEBD6;
    --selected-text:#050505;

    --black-dark: #050505;
    --black-regular: #333333;
    --black-light: #4C4C4C;
    --black-extra-light:#656565;

    --black-dark-shadow:#000000;

    --gray-dark: #999999;
    --gray-regular: #CCCCCC;
    --gray-light: #E5E5E5;
    --gray-extra-light: #F5F5F5;

    --background: #ffffff;
    --section:#000000;
    --body-color: #050505;
    --white:#ffffff;
  }

  :root {
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  :root {
    --border-radius: 4px;
  }

  :root {
    --mb-1: 8px;
    --mb-2: 16px;
    --mb-3: 24px;
    --mb-4: 32px;
    --mb-5: 40px;
    --mb-6: 48px;
  }

  :root {
    --z-back: -10;
    --z-normal: 1;
    --z-tooltip: 10;
    --z-fixed: 100;
    --z-aside: 150;
    --z-hamburger: 200;
  }

  :root {
    --font-black: 900;
    --font-bold: 800;
    --font-semi: 600;
    --font-normal: 400;
    --font-light: 300;
    
    --anchor-top:-40px;
    --header-height: 64px;
    --footer-min-height:40px;
  }

  :root {
    --body-font: "Poppins", sans-serif;
    --body-font-2: "Inconsolata", sans-serif;
    --smaller-font-size: 12px;
    --small-font-size: 14px;
    --normal-font-size: 15px;
    --normal-large-font-size: 18px;
    --big-font-size: 20px;
    --bigger-font-size: 35px;
    --icon-size:26px;
    --icon-btn-size:32px;

    @media screen and (min-width: 768px){
      :root{
        --smaller-font-size: 13px;
        --small-font-size: 15px;
        --normal-font-size: 16px;
        --normal-large-font-size: 20px;
        --big-font-size: 32px;
        --bigger-font-size: 56px;
        --icon-size:32px;
        --icon-btn-size:48px;
      }
  }
`;

export default variables;
